import { render } from "./ClipIcon.vue?vue&type=template&id=5c09b908"
import script from "./ClipIcon.vue?vue&type=script&lang=js"
export * from "./ClipIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__